<template>
	<div class="appView">
		<Sidebar></Sidebar>
		<div class="contentView expensesView" @click="isSort = false">
			<div class="navBar">
				<Hamburger />
				<div class="title">Expenses</div>
				<div class="separatorWhenSmallerThanMobile"></div>

				<div class="actions">
					<div class="action addReceipt" @click="addNew">
						<button>
							<img
								class="searchIcon"
								src="../../public/svg/plus-icon-white.svg"
							/>
							<span v-if="screenWidth > 420">Add Receipt</span>
							<span v-else>Add</span>
						</button>
					</div>
					<div class="action sort" @click.stop @click="isSort = !isSort">
						<button>
							<img
								v-if="isSortAsc"
								class="searchIcon"
								src="../../public/svg/filter-descending-icon.svg"
							/>
							<img
								v-else
								class="searchIcon"
								src="../../public/svg/filter-ascending-icon.svg"
							/>
							<span v-if="screenWidth > 420">Sort by</span>
							<span v-if="sortField == 'TransactionDate' || sortField == null"
								>Date</span
							>
							<span v-if="sortField == 'Amount'">Value</span>
							<span v-if="sortField == 'CategoryName'">Category</span>
							<span v-if="sortField == 'VendorName'">Vendor</span>
							<span v-if="sortField == 'ProjectName'">Project</span>
						</button>
						<div class="pickerView sortPicker" v-if="isSort">
							<div class="title">Sort Expenses</div>
							<div
								class="block"
								:class="sortField == 'TransactionDate' ? 'selected' : ''"
							>
								<div class="title" @click="sort('TransactionDate')">
									Date
									<font-awesome-icon
										class="iconSort"
										v-if="sortField == 'TransactionDate'"
										:icon="['fas', !isSortAsc ? 'caret-down' : 'caret-up']"
									/>
								</div>
							</div>
							<div
								class="block"
								:class="sortField == 'Amount' ? 'selected' : ''"
							>
								<div class="title" @click="sort('Amount')">
									Value
									<font-awesome-icon
										class="iconSort"
										v-if="sortField == 'Amount'"
										:icon="['fas', !isSortAsc ? 'caret-down' : 'caret-up']"
									/>
								</div>
							</div>
							<div
								class="block"
								:class="sortField == 'CategoryName' ? 'selected' : ''"
							>
								<div class="title" @click="sort('CategoryName')">
									Category
									<font-awesome-icon
										class="iconSort"
										v-if="sortField == 'CategoryName'"
										:icon="['fas', !isSortAsc ? 'caret-down' : 'caret-up']"
									/>
								</div>
							</div>
							<div
								class="block"
								:class="sortField == 'VendorName' ? 'selected' : ''"
							>
								<div class="title" @click="sort('VendorName')">
									Vendor
									<font-awesome-icon
										class="iconSort"
										v-if="sortField == 'VendorName'"
										:icon="['fas', !isSortAsc ? 'caret-down' : 'caret-up']"
									/>
								</div>
							</div>
							<div
								class="block"
								:class="sortField == 'ProjectName' ? 'selected' : ''"
							>
								<div class="title" @click="sort('ProjectName')">
									Project
									<font-awesome-icon
										class="iconSort"
										v-if="sortField == 'ProjectName'"
										:icon="['fas', !isSortAsc ? 'caret-down' : 'caret-up']"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="separatorWhenMobile"></div>
				<div class="action searchInput">
					<img
						class="searchIcon"
						src="../resources/images/icons/search-icon.svg"
					/>
					<input
						class="inputInside"
						type="text"
						v-on:input="searchData($event.target.value)"
						placeholder="Search All Expenses"
					/>
					<div class="clear"></div>
				</div>

				<div class="separatorWhenLaptop"></div>
			</div>

			<Loading :active.sync="isLoading" :is-full-page="false"></Loading>
			<div
				v-if="
					!isLoading &&
						Object.keys(receipts.reviewed).length === 0 &&
						receipts.unReviewed.length === 0 &&
						pendingExpense.receipts.length === 0
				"
				class="contentPlaceholder"
			>
				<div class="placeholderWrapper">
					<h6>Get Started</h6>
					<p>
						Welcome to RapidReceipt. Click “Add Receipt” button to upload your
						first receipt!
					</p>
				</div>
			</div>

			<div v-else class="expensesList tableView">
				<div v-if="!isSearch" class="tableSection">
					<div
						class="header"
						v-if="
							(pendingExpense.receipts && pendingExpense.receipts.length > 0) ||
								receipts.unReviewed.length > 0
						"
					>
						PENDING RECEIPTS
					</div>

					<div
						class="block expense receiptLoading"
						v-for="pending in pendingExpense.receipts"
						:key="pending.ReceiptId"
						@click="showInProgressReceiptModal(pending)"
					>
						<div class="icon">
							<div class="glyph loadingIcon">
								<SpinnerLoader :size="30" :color="'#fff'" />
							</div>
						</div>
						<div class="details loadingDetail">
							<div class="title vendor">Receipt Processing...</div>
							<div class="subtitle category">
								You'll be notified when it's ready.
							</div>
						</div>
					</div>

					<div class="break"></div>

					<div
						v-for="receipt in receipts.unReviewed"
						class="block expense"
						:class="'category' + receipt.icon"
						:key="receipt.ReceiptId"
						@click="updateReceipt(receipt.ReceiptId)"
					>
						<div class="icon">
							<div class="glyph"></div>
						</div>

						<div class="details">
							<div class="title vendor">{{ receipt.VendorName }}</div>
							<div class="subtitle category">{{ receipt.CategoryName }}</div>
						</div>
						<div class="value">
							<div class="review-button">
								<div class="text">Review</div>
							</div>
						</div>
					</div>
				</div>

				<div class="tableSection" v-for="key in keys" :key="key">
					<div class="header">{{ key | moment("dddd, MMMM D, YYYY") }}</div>

					<div
						v-for="receipt in receipts.reviewed[key]"
						class="block expense"
						:class="'category' + receipt.icon"
						:key="receipt.ReceiptId"
						@click="showDetail(receipt)"
					>
						<div class="icon">
							<div class="glyph"></div>
						</div>

						<div class="details">
							<div class="title vendor">{{ receipt.VendorName }}</div>
							<div class="subtitle category">{{ receipt.CategoryName }}</div>
						</div>
						<div class="value">
							{{ toFormatedCurrency((receipt.Amount * 100) / 100, "$") }}
						</div>
					</div>
				</div>
			</div>

			<Detail
				v-if="isShowDetail"
				id="detailModal"
				:expenses="[expense]"
				:userId="user_id"
				@close="closeDetail()"
			></Detail>
			<Create v-if="isCreate" id="createModal" @close="closeCreate()"></Create>
			<Edit
				v-if="editShow"
				id="expenseEdit"
				:receiptToPass="receiptToPass"
				@close="editShow = false"
			></Edit>
			<InProgressReceiptModal
				id="inProgressReceiptModal"
				v-if="isInProgressReceiptModalOpen"
				@close="isInProgressReceiptModalOpen = false"
				:currentPendingReceipt="currentPendingReceipt"
			>
				<template v-slot:header>
					This is a new modal header.
				</template>
			</InProgressReceiptModal>
		</div>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { SpinnerLoader } from "vue-spinners-css";
import Edit from "../components/ExpenseEdit.vue";
import Sidebar from "../components/Sidebar.vue";
import Detail from "../components/ExpenseDetail.vue";
import Create from "../components/ExpenseCreate.vue";
import InProgressReceiptModal from "../components/InProgressReceiptModal.vue";
import { getUserId } from "../utils/auth";
import { mapState } from "vuex";
import { setTimeStamp } from "../utils/general";
window._ = require("lodash");
import moment from "moment";
import Hamburger from "../components/Hamburger.vue";

export default {
	data() {
		return {
			dates: [],
			isLoading: true,
			isShowDetail: false,
			isCreate: false,
			expense: null,
			user_id: getUserId(),
			pendingCheck: null,
			isSearch: false,
			isSort: false,
			isSortAsc: false,
			sortField: "TransactionDate",
			keyword: "",
			editShow: false,
			receiptToPass: {},
			isInProgressReceiptModalOpen: false,
			currentPendingReceipt: {}
		};
	},
	components: {
		Sidebar,
		Detail,
		Create,
		Loading,
		SpinnerLoader,
		Edit,
		InProgressReceiptModal,
		Hamburger
	},
	computed: {
		...mapState(["attributes", "pendingExpense", "activeExpense"]),
		receipts: function() {
			var retVal = this.activeExpense;
			// search
			if (this.isSearch) {
				retVal = _.filter(retVal, result => {
					// Check keyword is includes in Category Name, Vendor Name and Amount
					if (
						_.includes(
							result.CategoryName.toLowerCase(),
							this.keyword.toLowerCase()
						) ||
						_.includes(
							result.VendorName.toLowerCase(),
							this.keyword.toLowerCase()
						) ||
						_.includes(result.Amount, this.keyword)
					) {
						return result;
					}
				});
			}

			const partitioned = _.partition(retVal, { Reviewed: 0 });
			const unReviewed = partitioned[0];
			retVal = partitioned[1];

			retVal = _.sortBy(retVal, "VendorName");

			if (this.sortField != "Amount") {
				retVal = _.groupBy(retVal, this.sortField);
			} else {
				if (this.isSortAsc) retVal = _.sortBy(retVal, ["Amount", "VendorName"]);
				else retVal = _.sortBy(retVal, ["Amount", "VendorName"]).reverse();
				retVal = { "": retVal };
			}
			return { reviewed: retVal, unReviewed: unReviewed };
		},
		keys: function() {
			var retVal = _.keys(this.receipts.reviewed);
			if (this.isSortAsc) retVal = _.sortBy(retVal);
			else retVal = _.sortBy(retVal).reverse();
			return retVal;
		}
	},
	async mounted() {
		try {
			this.isLoading = true;
			await this.$store.dispatch("loadAttribute");
			await this.$store.dispatch("loadPendingExpense");
			await this.$store.dispatch("loadActiveExpense");
		} catch (error) {
			return error;
		} finally {
			this.isLoading = false;
			setTimeStamp(moment().unix());
			this.checkData();
		}
	},
	beforeDestroy() {
		clearInterval(this.pendingCheck);
	},
	methods: {
		checkData() {
			const self = this;
			if (
				this.pendingExpense.receipts &&
				this.pendingExpense.receipts.length > 0
			) {
				if (!this.pendingCheck) {
					this.pendingCheck = setInterval(function() {
						self.reloadData();
					}, 2000);
				}
			} else {
				clearInterval(this.pendingCheck);
			}
		},
		async reloadData() {
			await this.$store.dispatch("loadPendingTimestamp");
			if (this.pendingExpense.receipts.length == 0) {
				clearInterval(this.pendingCheck);
			}
		},
		searchData(keyword) {
			const self = this;
			if (keyword) {
				this.isSearch = true;
				this.keyword = keyword;
			} else {
				this.isSearch = false;
			}
		},
		showDetail(expense) {
			this.expense = expense;
			this.isShowDetail = true;
		},
		addNew() {
			this.isCreate = true;
		},
		closeCreate() {
			this.isCreate = false;
			this.checkData();
		},
		closeDetail() {
			this.isShowDetail = false;
		},
		sort(passvalue) {
			if (this.sortField == passvalue) {
				this.isSortAsc = !this.isSortAsc;
			} else {
				if (passvalue == "TransactionDate") this.isSortAsc = false;
				else this.isSortAsc = true;
			}
			this.sortField = passvalue;
		},
		updateReceipt(id) {
			this.receiptToPass = id;
			this.editShow = true;
		},
		updatedExpense(expense) {
			this.editShow = false;
		},
		showInProgressReceiptModal(pendingReceipt) {
			this.isInProgressReceiptModalOpen = true;
			this.currentPendingReceipt = pendingReceipt;
		},
		async deleteInProgressReceipt(receiptId) {
			console.log(receiptId.Document);
		}
	}
};
</script>
